import Administracja from './Administracja';
export default Administracja;